module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pageCalendar",
    staticClass: "wxc-page-calendar",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle({
      height: _vm.pageHeight + 'px'
    }))
  }, [_c('wxc-minibar', _vm._b({
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined)),
    attrs: {
      "show": _vm.showHeader,
      "use-default-return": _vm.useDefaultReturn
    },
    on: {
      "wxcMinibarLeftButtonClicked": _vm.minibarLeftButtonClick
    }
  }, 'wxc-minibar', _vm.minibarCfg, false)), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "calendar-weekday",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, _vm._l((['日', '一', '二', '三', '四', '五', '六']), function(week, k) {
    return _c('text', {
      key: k,
      staticClass: "flex-item weekday-text",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined)),
      attrs: {
        "aria-label": ("周" + week)
      }
    }, [_vm._v(_vm._s(week))])
  })) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('list', {
    staticClass: "calendar-list",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle({
      height: _vm.calendarHeight + 'px'
    }))
  }, _vm._l((_vm.monthsArray), function(month, index) {
    return _c('cell', {
      key: index,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_c('div', {
      staticClass: "calendar-month",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_c('text', {
      staticClass: "month-text",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_vm._v(_vm._s(month.title))])]), _vm._v(" "), _vm._l((month.rowsData), function(row, rowIndex) {
      return _c('div', {
        key: rowIndex,
        staticClass: "calendar-row",
        staticStyle: _vm.$processStyle(undefined),
        style: (_vm.$processStyle(undefined))
      }, _vm._l((row.cells), function(cell, index) {
        return _c('div', {
          key: index,
          ref: cell.ref,
          refInFor: true,
          class: ['row-item', cell.cellClass],
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined)),
          on: {
            "click": function($event) {
              _vm.onClickDate(cell)
            }
          }
        }, [(cell.isEmpty) ? _c('div', {
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined)),
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), (!cell.isEmpty) ? _c('div', {
          staticClass: "calendar-item",
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined)),
          attrs: {
            "accessible": true,
            "aria-label": ((cell.text?cell.text:'') + "," + (cell.note?cell.note:'') + "," + (cell.ext?cell.ext:''))
          }
        }, [_c('text', {
          class: ['calendar-note', cell.cls],
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined))
        }, [_vm._v(_vm._s(cell.note))]), _vm._v(" "), _c('text', {
          class: ['calendar-day', cell.cls],
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined))
        }, [_vm._v(_vm._s(cell.text))]), _vm._v(" "), _c('text', {
          class: ['calendar-ext', cell.cls],
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined))
        }, [_vm._v(_vm._s(cell.ext))])]) : _vm._e()])
      }))
    })], 2)
  })) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3472bf4f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3472bf4f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-page-calendar/index.vue
// module id = 180
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28